'use strict';

module.exports = [require('./erf')];


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/mathjs/lib/function/special/index.js
// module id = bj46
// module chunks = 15